export default __webpack_public_path__ + "static/media/c.77377419.svg";